// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_transactions_btn-primary__DX-Xl","label":"_transactions_label__2Ba7i","select":"_transactions_select__3_kmb"};